export default __webpack_public_path__ + "static/media/computer.59afeffc.png";